/**
 Integer from 0-4 (useful for implementing a strength bar):
 - 0 too guessable: risky password. (guesses 10^3)
 - 1 very guessable: protection from throttled online attacks. (guesses 10^6)
 - 2 somewhat guessable: protection from unthrottled online attacks. (guesses 10^8)
 - 3 safely unguessable: moderate protection from offline slow-hash scenario. (guesses 10^10)
 - 4 very unguessable: strong protection from offline slow-hash scenario. (guesses >= 10^10)
 */
export enum ZxcvbnScore {
  NoScore = -1,
  TooGuessable = 0,
  VeryGuessable = 1,
  SomewhatGuessable = 2,
  SafelyUnguessable = 3,
  VeryUnguessable = 4,
}
